import React from 'react';
import PropTypes from 'prop-types';

import NumberOrTimeInput  from './NumberOrTimeInput';
import NumberOrTimePlusInput from './NumberOrTimePlusInput';
import {
  checkIfTouchedValue,
  isTimeFormula,
  floatToTime,
  timeToFloat,
  splitAmountAndWage,
  findChanges,
  NUMBER_OR_TIME_REGEX
} from './utilities';

class Plus2Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTimeFormat: false,
      hasUpdatedOnce: false
    };
  }

  componentDidUpdate() {
    const { userPayrolls, inputType, idx } = this.props;

    if (userPayrolls.length > 0 && !this.state.hasUpdatedOnce) {
      const isTimeFormat = userPayrolls.some((userPayroll) => isTimeFormula(userPayroll[`${inputType}`][idx]));

      this.setState({ isTimeFormat: isTimeFormat, hasUpdatedOnce: true });
    }
  }

  convertTimeData = () => {
    const { idx, userPayrolls, inputType, setValueChanged } = this.props;
    const user_payrolls_tmp = JSON.parse(JSON.stringify(userPayrolls));
    let changes = [];

    this.setState({ isTimeFormat: !this.state.isTimeFormat }, () =>{
      user_payrolls_tmp.map((up, index) => {
        if (NUMBER_OR_TIME_REGEX.test(up[`${inputType}`][idx])) {
          const { wage, amount } = splitAmountAndWage(up[`${inputType}`][idx]);
          const formattedAmount = isTimeFormula(up[`${inputType}`][idx]) ? timeToFloat(amount) : floatToTime(amount);

          up[`${inputType}`][idx] = `${wage}*${formattedAmount}`;
          up['puPlus2s'] = up[`${inputType}`].join('::');
        }

        changes = [...changes, ...findChanges(up.uID, up, userPayrolls[index])];
      });

      setValueChanged(changes, user_payrolls_tmp);
    });
  };

  render() {
    const { idx,
      puPlusEditDisplay,
      text,
      textExisted,
      handlePayrollChange,
      waggerTimerDisplay,
      userPayrolls,
      touched,
      imageTimerUrl,
      imageEditUrl,
      toggleTimer,
      toggleEdit,
      onPlusChange,
      onPlusFocus,
      onWageChange,
      onWageFocus,
      clearAmount,
      onAmountChange,
      onAmountFocus,
      inputType,
      useTimeFormat,
      hasNameError,
      hasDeductionWarning,
    } = this.props;

    return (
      <React.Fragment key={`puPlus2Text_${idx}`}>
        <tr>
          {textExisted ?
            <th className="item th2">
              <div className="wageTimerWrapper">
                {puPlusEditDisplay ?
                  <input className={`pay-columns ${hasNameError ? 'name-length-error' : ''} ${hasDeductionWarning ? 'deduction-warning' : ''}`}
                    defaultValue={text}
                    name={`puPlus2Texts[${idx}]`}
                    onChange={handlePayrollChange}
                    type="text"
                  />
                  :
                  <div>
                    <span>{text}</span>
                  </div>
                }
                <button className={`btn btn-sm wageTimer wageEdit indexEditPlus2_${idx} ${text !== '' && 'plusEdit'} ${puPlusEditDisplay && 'btn-success'}`}
                  data-bs-toggle="tooltip"
                  disabled={hasNameError}
                  onClick={toggleEdit}
                  title="時給&#013;日給"
                >
                  <img alt="時" src={imageEditUrl} />
                </button>
                <button className={`btn btn-sm wageTimer indexWageTimer_${idx} ${(puPlusEditDisplay || text === '') && 'hide'} ${waggerTimerDisplay && 'btn-success'}`}
                  data-bs-toggle="tooltip"
                  onClick={toggleTimer}
                  title="時給&#013;日給"
                >
                  <img alt="時" src={imageTimerUrl} />
                </button>
              </div>
            </th>
            :
            <td className="item th2">
              <input className={`pay-columns ${hasNameError ? 'name-length-error' : ''} ${hasDeductionWarning ? 'deduction-warning' : ''}`}
                name={`puPlus2Texts[${idx}]`}
                onChange={handlePayrollChange}
                placeholder="+ 支給項目を追加"
                type="text"
                value={ text }
              />
            </td>
          }
          {userPayrolls.map((userPayroll, index) => {
            return (
              <td className="salary w9" key={`puPlus2_pu_${index}`}>
                <NumberOrTimePlusInput className={`inputNumber w9 ${checkIfTouchedValue(touched, userPayroll.uID, 'puPlus2s', idx) ? 'updated' : ''}`}
                  data-uid={userPayroll.uID}
                  inputType={inputType}
                  isTimeFormat={this.state.isTimeFormat}
                  name={`payment[${userPayroll.uID}][puPlus2][${idx}]`}
                  onChange={(e) => onPlusChange(e, index, 'puPlus2Texts', idx)}
                  onFocus={(e) => onPlusFocus(e, userPayroll.uID, `puPlus2s_${idx}`)}
                  type="text"
                  useTimeFormat={useTimeFormat}
                  value={userPayroll['puPlus2Texts'][idx] || ''}
                />
              </td>
            );
          })}
        </tr>
        {
          text !== '' && waggerTimerDisplay &&
            <>
              <tr key={`puPlus2Wage_${text}_${idx}`}>
                <th className="item th2 wage">
                  <span>┣ 単価</span>
                </th>
                {userPayrolls.map((userPayroll, index) => {
                  return (
                    <td className="salary w9" key={`puPlus2Wage_up_${index}`}>
                      <input className="inputNumber w9"
                        data-uid={userPayroll.uID}
                        name={`payment[${userPayroll.uID}][puPlus2Wage][${idx}]`}
                        onChange={(e) => onWageChange(e, index, 'puPlus2WageTexts', idx)}
                        onFocus={(e) => onWageFocus(e, userPayroll.uID, `puPlus2s_wage_${idx}`)}
                        type="text" value={userPayroll['puPlus2WageTexts'][idx] || ''}
                      />
                    </td>
                  );
                })}
              </tr>
              <tr key={`puPlus2Amount_${text}_${idx}`}>
                <th className="item th2 wage">
                  <span>┗ 時/日数</span>
                  <div className="tools-box">
                    { this.props.useTimeFormat &&
                      <button
                        className={`btn btn-sm badge hover-badge convert-puPlus2-${idx}-amounts`}
                        onClick={() => this.convertTimeData()}
                      >
                        {this.state.isTimeFormat ? '時間' : '数' }
                      </button>
                    }
                    <a className="badge badge-mini hover-badge wageClear" data-bs-toggle="tooltip"
                      href="#" name={`payment[puPlus2WageClear][${idx}]`}
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); clearAmount(); }}
                      title="時間数/日数をクリア"
                    >X
                    </a>
                  </div>
                </th>
                {userPayrolls.map((userPayroll, index) => {
                  return (
                    <td className="salary w9" key={`puPlus2Amount_up_${index}`}>
                      <NumberOrTimeInput
                        className="inputNumber w9"
                        data-uid={userPayroll.uID}
                        inputType={inputType}
                        isTimeFormat={this.state.isTimeFormat}
                        name={`payment[${userPayroll.uID}][puPlus2Amount][${idx}]`}
                        onChange={(e) => onAmountChange(e, index, 'puPlus2AmountTexts', idx)}
                        onFocus={(e) => onAmountFocus(e, userPayroll.uID, `puPlus2s_amount_${idx}`)}
                        type="text" value={userPayroll['puPlus2AmountTexts'][idx] || ''}
                      />
                    </td>
                  );
                })}
              </tr>
            </>
        }
      </React.Fragment>
    );
  }
}

Plus2Input.defaultProps = {
  useTimeFormat: false,
  inputType: 'puPlus2Texts'
};

Plus2Input.propTypes = {
  idx: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  inputType: PropTypes.string.isRequired,
  puPlusDisplay: PropTypes.bool.isRequired,
  puPlusEditDisplay: PropTypes.bool.isRequired,
  textExisted: PropTypes.bool.isRequired,
  waggerTimerDisplay: PropTypes.bool.isRequired,
  toggleEdit: PropTypes.func.isRequired,
  imageTimerUrl: PropTypes.string.isRequired,
  imageEditUrl: PropTypes.string.isRequired,
  userPayrolls: PropTypes.array.isRequired,
  touched: PropTypes.array.isRequired,
  toggleTimer: PropTypes.func.isRequired,
  onPlusChange: PropTypes.func.isRequired,
  handlePayrollChange: PropTypes.func.isRequired,
  onPlusFocus: PropTypes.func.isRequired,
  onWageChange: PropTypes.func.isRequired,
  onWageFocus: PropTypes.func.isRequired,
  clearAmount: PropTypes.func.isRequired,
  setValueChanged: PropTypes.func.isRequired,
  onAmountChange: PropTypes.func.isRequired,
  onAmountFocus: PropTypes.func.isRequired,
  useTimeFormat: PropTypes.bool.isRequired,
};

export default Plus2Input;
